import { useMutation, useQueryClient } from "@tanstack/react-query"
import { sendNotification } from "../../services/notification";
import {  IIndicators } from "../../types";
import { toast } from "react-toastify";

const useSendNotification = (indicators: IIndicators) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: sendNotification,

        onMutate: () => {
            indicators.setIsProcessRunning(true);
        },

        onSuccess: (status) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ['notifications'] });
                indicators.setIsProcessRunning(false);
                toast.success('Notification sent successfully')
            }
        },

        onError: (error: any) => {
            indicators.setIsProcessRunning(false);
            toast.error(error.response?.data?.message);
            indicators.setIsServiceError(error.response?.data?.message);
        }
    });
};

export default useSendNotification;